const AgeGate = () => import(/* webpackChunkName: "age-gate" */ './src/views/AgeGate')

const install = function(Vue, globalOptions) {
  Vue.component('age-gate', AgeGate)
}

export default { install }
